const tokenKey = "user_token";

export function getToken() {
  return sessionStorage.getItem(tokenKey);
}

export function setToken(token) {
  return sessionStorage.setItem(tokenKey, token);
}

export function removeToken() {
  return sessionStorage.removeItem(tokenKey);
}

// export function getCookie(name) { //获取指定名称的cookie值
// 	// (^| )name=([^;]*)(;|$),match[0]为与整个正则表达式匹配的字符串，match[i]为正则表达式捕获数组相匹配的数组；
// 	var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
// 	if (arr != null) {
// 		return unescape(arr[2]);
// 	}
// 	return null;
// }
